import { useEffect } from "react";
import { API_BASE_URL } from "../api/config";

const Login = ({ onLogin }) => {
    useEffect(() => {
        const tg = window.Telegram?.WebApp

        if (tg && tg.initData) {
            tg.ready();
            fetch(`${API_BASE_URL}/auth/miniapp/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ initData: tg.initData })
            })
            .then(res=>res.json())
            .then(data => {
                if (data.token) {
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('name', data.name);
                    onLogin();
                } else {
                    tg.showAlert('Access denied. You are not an admin.');
                }
            })
            .catch(() => tg.showAlert('Login failed. Try again'));
        }
    }, [onLogin]);
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-background-600">
            <div className="bg-primary-800 rounded-2xl p-8 w-full max-w-sm mx-4">
                <h1 className="text-white text-2xl font-bold mb-2 text-center">Admin Panel</h1>
                <p className="text-primary-50 text-xs font-mono text-center mb-8">CLEANING MIAMI</p>
                <p className="text-primary-10 text-xs text-center">Open this app through Telegram to login.</p>
            </div>
        </div>
    );
};

export default Login;